import { render, staticRenderFns } from "./WalletInfo.vue?vue&type=template&id=ec722b7a&scoped=true&"
import script from "./WalletInfo.vue?vue&type=script&lang=js&"
export * from "./WalletInfo.vue?vue&type=script&lang=js&"
import style0 from "./WalletInfo.vue?vue&type=style&index=0&id=ec722b7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec722b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec722b7a')) {
      api.createRecord('ec722b7a', component.options)
    } else {
      api.reload('ec722b7a', component.options)
    }
    module.hot.accept("./WalletInfo.vue?vue&type=template&id=ec722b7a&scoped=true&", function () {
      api.rerender('ec722b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brand/list/children/detail/components/WalletInfo.vue"
export default component.exports